var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKn = function SvgKn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.515 20.485c.504.503 1.04.953 1.604 1.348L21.834 5.119a12.065 12.065 0 0 0-2.952-2.952L2.168 18.881c.395.564.844 1.1 1.347 1.604Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M3.514 3.515C-.272 7.3-.998 12.986 1.333 17.502L17.502 1.333C12.986-.997 7.3-.27 3.514 3.515Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M20.485 20.485c3.786-3.786 4.513-9.472 2.182-13.988L6.498 22.667c4.516 2.33 10.202 1.603 13.987-2.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m7.63 14.158 1.12.57.889-.888-.197 1.241 1.12.571-1.241.197-.197 1.241-.57-1.12-1.242.197.889-.889-.571-1.12ZM14.156 7.63l1.12.571.89-.889-.197 1.242 1.12.57-1.242.198-.197 1.241-.57-1.12-1.242.197.889-.89-.57-1.12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgKn;